import React, { useState } from "react";
import { FiPlus, FiMinus } from 'react-icons/fi'


const Venue = () => {
  const VenueQuestions = [
    {
      id: 1,
      question: "WHERE IS THE ENTRANCE TO DREAMY DRAW?",
      answer: "The entrance is located at 7380 E 2nd St, Scottsdale.",
    },
    {
      id: 9,
      question: "WILL FOOD/WATER BE AVAILABLE?",
      answer:
        "There will be free water filling stations at the event. Other drink and food options will be available for purchase throughout the Festival.",
    },
    {
      id: 12,
      question: "IS RE-ENTRY ALOWED?",
      answer: "No re-entry is allowed.",
    },
  ];

  const [clicked, setClicked] = useState(false)

  const toggle = index => {
    // if the clicked question is open, then close it.
    if (clicked === index) {
      return setClicked(null)
    }
    // else, open the question when its clicked on
    setClicked(index)
  }
  return (

    <div className="faqs-container" id="venueQuestions">
      <h1>Venue</h1>
      {VenueQuestions.map((faq, index) => {
        return (
          <div key={index}>
            <div className="faqs-question" onClick={() => toggle(index)}>
              <h1>{faq.question}</h1>
              <span>{clicked === index ? <FiMinus color="#ffffff" /> : <FiPlus color="#ffffff" />}</span>
            </div>
            {clicked === index ? (
              <div className="faqs-answer">
                <p>{faq.answer}</p>
              </div>
            ) : null}

          </div>
        )
      })}
    </div>
  );
};

export default Venue;
